<template>
  <div class="" v-if="!check">
    <div class="">
      <div class="registration-head text-center" :style="styleHeader">
        <div class="sml-container">
          <div class="rg-head">
            <h1>キャリア登録ページ</h1>
          </div>
        </div>
      </div>
      <div class="sml-container">
        <div class="career-img" style="border-bottom: 1px solid #C4C4C4">
          <!-- <img src="./../assets/images/career-img.png" alt="logo" class="img-fluid"/> -->
          <img
            src="./../assets/images/career-img-svg-2.svg"
            alt="logo"
            class="img-fluid"
            style="height:100%;width:100%"
          />
          <p class="text-center mobile-break" style="font-size: 16px;">
            適したポジションがある際に連絡が届きます。<br class="mobile-only">
            ご希望の方は以下より情報をご登録ください。
          </p>
        </div>
      </div>
      <div class="sml-container">
        <div class="rgst-sec">
          <div class="rgst-dtl-sec">
            <BRegistration :endpointKey="'bloomValidate'" @redirectToPreviewPage="redirectToPreview"/>
          </div>
        </div>  
      </div>
    </div>
    <!-- ends main-area -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BRegistration from "./BRegistration.vue";
export default {
  name: "BloomRegistration",
  components: { BRegistration },
  data() {
    return {
      check: true
    }
  },
  computed: {
    styleHeader() {
      return { background: "#006C6B" };
    },
  },
  methods: {
    ...mapActions({
      setBloomData: "setBloomData",
      checkMaintenance: "checkMaintenance",
    }),
    redirectToPreview(){
      this.$router.push({name: 'preview2'})
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
  },
  async mounted() {
    this.scrollToTop();
    await this.setBloomData(true);
  },
  async created() {
    const check = await this.checkMaintenance();
    this.check = check;
    if (check) this.$router.push({ name: "Maintenance" });
  },
};
</script>

<style scoped>
h5 {
  text-align: center !important;
  font-size: 23px;
}
.registration-head{
  display: flex;
  justify-content: center;
  align-items: center;
}
.rg-head {
  display: flex;
  align-items: center;
}
.mobile-break .mobile-only {
  display: none;
}
@media (max-width: 767px) {
  .mobile-break .mobile-only {
    display: inline;
  }

  .mobile-break {
    font-size: 16px;
  }
}
</style>
